import apiClient from './client';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface RegisterData {
  email: string;
  password: string;
  full_name?: string;
  public_jwk: string;
  encrypted_private_jwk: string;
  kdf_salt_b64: string;
  kdf_iterations: number;
  kdf_hash: string;
  priv_enc_alg: string;
  priv_enc_iv_b64: string;
}

export type ViewMode = 'simplified' | 'advanced';

export interface User {
  id: number;
  email: string;
  full_name: string | null;
  is_active: boolean;
  is_admin?: boolean;
  preferred_llm_provider?: string | null;
  preferred_llm_model?: string | null;
  // 'simplified' (default) hides power-user UI; 'advanced' shows everything.
  view_mode?: ViewMode;
  created_at: string;
}

export interface TokenResponse {
  access_token: string;
  token_type: string;
}

export const authApi = {
  emailAvailable: async (email: string): Promise<{ available: boolean }> => {
    const response = await apiClient.get('/api/auth/email-available', { params: { email } });
    return response.data;
  },

  login: async (credentials: LoginCredentials): Promise<TokenResponse> => {
    const formData = new FormData();
    formData.append('username', credentials.username);
    formData.append('password', credentials.password);
    
    const response = await apiClient.post('/api/auth/login', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  register: async (data: RegisterData): Promise<User> => {
    const response = await apiClient.post('/api/auth/register', data);
    return response.data;
  },

  getMe: async (): Promise<User> => {
    const response = await apiClient.get('/api/auth/me');
    return response.data;
  },

  updateMe: async (data: { full_name?: string | null; view_mode?: ViewMode }): Promise<User> => {
    const response = await apiClient.patch('/api/auth/me', data);
    return response.data;
  },

  changePassword: async (data: { current_password: string; new_password: string }): Promise<void> => {
    await apiClient.post('/api/auth/change-password', data);
  },
};
